module.exports = __webpack_public_path__ + "static/img/banner-2.e4a4557.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/banner-2.jpg
// module id = ojX4
// module chunks = 1